module.exports = __webpack_public_path__ + "static/Graeme-Atherton-b62a5b1ea5a9c22eee4c72b27621332f.jpg";